module.exports = __webpack_public_path__ + "static/2-b2c70342412adb4b0281f3b368c75771.webp";